import { t as __t } from "i18next";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../dashboard-shell-green.css";

const SidebarHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="pro-header gwin-offcanvas-header">
      <Link to="/admin/dashboard" className="gwin-offcanvas-brand" data-bs-dismiss="offcanvas">
        <img src="/images/lti_logo.png" alt="brand" className="gwin-offcanvas-logo" />
        <span className="gwin-offcanvas-brand-copy">
          <strong>LTI Insurance</strong>
          <small>{__t("uiText.text374")}</small>
        </span>
      </Link>

      <button
        type="button"
        className="fix-icon gwin-offcanvas-close"
        data-bs-dismiss="offcanvas"
        aria-label={t("accessibility.close")}
      >
        <span className="flaticon-close" />
      </button>
    </div>
  );
};

export default SidebarHeader;
